import React from 'react'
import { DateRangeDropdown } from '@contrast-security-inc/design-system-inputs'
import {
  defaultDateRange,
  UseVrDateFilterManagerChildResponse
} from './use-vr-date-filter-manager'
import { useIntl } from 'react-intl'

export const vrDateFilterDropdownTestId = 'vr-date-filter-dropdown-test-id'

export const VrDateFilterDropdown = (
  dateFilterManagerProps: UseVrDateFilterManagerChildResponse
) => {
  const intl = useIntl()

  return (
    <DateRangeDropdown
      items={[
        {
          count: 7,
          unit: 'DAYS',
          type: 'RELATIVE_TO_NOW'
        },
        {
          count: 30,
          unit: 'DAYS',
          type: 'RELATIVE_TO_NOW'
        },
        {
          count: 12,
          unit: 'MONTHS',
          type: 'RELATIVE_TO_NOW'
        },
        {
          type: 'CUSTOM_DATE_RANGE'
        }
      ]}
      label={intl.formatMessage({
        id: 'title_valueReporting_selectDateRange'
      })}
      inputHeight={35}
      style={{ width: 400, zIndex: 1 }}
      wrapCustomDateRange={false}
      data-testid={vrDateFilterDropdownTestId}
      onChangeRange={dateFilterManagerProps.onDateRangeOptionSelect}
      selectedRange={
        dateFilterManagerProps.selectedDateRange ?? defaultDateRange
      }
    />
  )
}
